import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { defineMessages } from '@/lib/i18n';
import {
  getTemperatureUnitList,
  getSection9InequalityList,
} from '@/lib/formItem';
import { isFloat, required } from '@/lib/rule';
import { TemperatureUnitId } from '@/lib/enum';
import { i18n } from '@/plugins/vue-i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection9FlashPointForm',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: false,
  },
  unitId: {
    type: Number,
    required: true,
  },
  flashPointMin: {
    type: Number,
    required: true,
  },
  flashPointMax: {
    type: Number,
    required: true,
  },
  measurementMethod: {
    type: String,
    required: true,
  },
  flashPointInequalitySign: {
    type: Number,
    required: true,
  },
},
  emits: ["update:isValid", "update:unitId", "update:flashPointMin", "update:flashPointMax", "update:measurementMethod", "update:flashPointInequalitySign"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:unitId', data: number): void;
  (e: 'update:flashPointMin', data: number): void;
  (e: 'update:flashPointMax', data: number): void;
  (e: 'update:measurementMethod', data: string): void;
  (e: 'update:flashPointInequalitySign', data: number): void;
}), expose: any, slots: any, attrs: any }) {

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  flashPointInequalitySign: '引火点不等号',
});



const form = ref<string>('');



const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateUnitId = (e: number): void => {
  emits('update:unitId', e);
};

const updateFlashPointMin = (e: string): void => {
  if (isNaN(Number(e))) {
    return;
  }

  emits('update:flashPointMin', Number(e));
};

const updateFlashPointMax = (e: string): void => {
  if (isNaN(Number(e))) {
    return;
  }

  emits('update:flashPointMax', Number(e));
};

const updateFlashPointInequalitySign = (e: number): void => {
  emits('update:flashPointInequalitySign', e);
};

const updateMeasurementMethod = (e: string): void => {
  emits('update:measurementMethod', e);
};

const inequalityMin = (inequalityMin: number): string => {
  switch (inequalityMin) {
    case 1:
      return $t(sharedMessages.equal);
    case 2:
    case 6:
    case 7:
      return $t(sharedMessages.greaterThanOrEqual);
    case 3:
    case 8:
    case 9:
      return $t(sharedMessages.greaterThan);
    default:
      return '';
  }
};

const inequalityMax = (inequalityMax: number): string => {
  switch (inequalityMax) {
    case 4:
    case 6:
      return $t(sharedMessages.lessThanOrEqual);
    case 5:
    case 7:
    case 9:
      return $t(sharedMessages.lessThan);
    default:
      return '';
  }
};

onMounted((): void => {
  if (form.value) {
    // @ts-expect-error: validate method is missing type definition
    form.value.validate();
  }
});

return { __sfc: true,$t, m, form, emits, updateIsValid, updateUnitId, updateFlashPointMin, updateFlashPointMax, updateFlashPointInequalitySign, updateMeasurementMethod, inequalityMin, inequalityMax, getTemperatureUnitList, getSection9InequalityList, isFloat, required, TemperatureUnitId, sharedMessages }
}

})